module.exports = __webpack_public_path__ + "media/2InstabilityGapWideningGranulationTissue.350c0ef4.mp3";